// The hero slider's photographs, in every size the browser can choose from.
//
// Sources, licence and how each file was made: Assets/hero/CREDITS.md.
//
// Each photo has a landscape set (16:9, up to 4K) and a portrait set (9:16)
// for phones held upright, so a phone never downloads a 4K landscape file
// to show a narrow slice of it. Imported rather than put in /public so the
// build fingerprints them and the server can cache them for a year.

import rooftop1280 from "../../Assets/hero/rooftop-1280.webp";
import rooftop1920 from "../../Assets/hero/rooftop-1920.webp";
import rooftop2560 from "../../Assets/hero/rooftop-2560.webp";
import rooftop3130 from "../../Assets/hero/rooftop-3130.webp";
import rooftopP828 from "../../Assets/hero/rooftop-p828.webp";
import rooftopP1242 from "../../Assets/hero/rooftop-p1242.webp";

import install1280 from "../../Assets/hero/install-1280.webp";
import install1920 from "../../Assets/hero/install-1920.webp";
import install2560 from "../../Assets/hero/install-2560.webp";
import install3840 from "../../Assets/hero/install-3840.webp";
import installP828 from "../../Assets/hero/install-p828.webp";
import installP1242 from "../../Assets/hero/install-p1242.webp";

import stock1280 from "../../Assets/hero/stock-1280.webp";
import stock1920 from "../../Assets/hero/stock-1920.webp";
import stock2560 from "../../Assets/hero/stock-2560.webp";
import stock3840 from "../../Assets/hero/stock-3840.webp";
import stockP828 from "../../Assets/hero/stock-p828.webp";
import stockP1242 from "../../Assets/hero/stock-p1242.webp";

import money1280 from "../../Assets/hero/money-1280.webp";
import money1920 from "../../Assets/hero/money-1920.webp";
import money2560 from "../../Assets/hero/money-2560.webp";
import money3840 from "../../Assets/hero/money-3840.webp";
import moneyP828 from "../../Assets/hero/money-p828.webp";
import moneyP1242 from "../../Assets/hero/money-p1242.webp";

const set = (pairs) => pairs.map(([src, w]) => `${src} ${w}w`).join(", ");

const photo = (landscape, portrait, fallback) => ({
    srcSet: set(landscape),
    portraitSrcSet: set(portrait),
    src: fallback,
});

const HERO_PHOTOS = {
    rooftop: photo(
        [[rooftop1280, 1280], [rooftop1920, 1920], [rooftop2560, 2560], [rooftop3130, 3130]],
        [[rooftopP828, 828], [rooftopP1242, 1242]],
        rooftop1920,
    ),
    install: photo(
        [[install1280, 1280], [install1920, 1920], [install2560, 2560], [install3840, 3840]],
        [[installP828, 828], [installP1242, 1242]],
        install1920,
    ),
    stock: photo(
        [[stock1280, 1280], [stock1920, 1920], [stock2560, 2560], [stock3840, 3840]],
        [[stockP828, 828], [stockP1242, 1242]],
        stock1920,
    ),
    money: photo(
        [[money1280, 1280], [money1920, 1920], [money2560, 2560], [money3840, 3840]],
        [[moneyP828, 828], [moneyP1242, 1242]],
        money1920,
    ),
};

export default HERO_PHOTOS;
